// ============================================================
// UrbanWear — Notifications (toasts) + LoadingScreen
// ============================================================

import { useUIStore } from '@/store'
import styles from './Notifications.module.css'

export default function Notifications() {
  const notifications = useUIStore(s => s.notifications)
  const dismiss       = useUIStore(s => s.dismissNotif)

  if (notifications.length === 0) return null

  return (
    <div className={styles.container} aria-live="polite">
      {notifications.map(n => (
        <div key={n.id} className={`${styles.toast} ${styles[n.type]}`}>
          <i className={`ti ${
            n.type === 'success' ? 'ti-circle-check' :
            n.type === 'error'   ? 'ti-circle-x' : 'ti-info-circle'
          }`} />
          <span>{n.message}</span>
          <button
            onClick={() => dismiss(n.id)}
            className={styles.close}
            aria-label="Cerrar notificación"
          >
            <i className="ti ti-x" />
          </button>
        </div>
      ))}
    </div>
  )
}
